import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebaseConfig";
import "../../styles/auth.css";

export default function Signup() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [pass2, setPass2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onCreate = async (e) => {
    e.preventDefault();
    setError("");

    if (pass.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres.");
      return;
    }
    if (pass !== pass2) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    setLoading(true);
    try {
      await createUserWithEmailAndPassword(auth, email.trim(), pass);
      navigate("/panel", { replace: true });
    } catch (err) {
      const msg =
        err?.code === "auth/email-already-in-use" ? "Ese correo ya está registrado." :
        err?.code === "auth/invalid-email" ? "Correo inválido." :
        "No se pudo crear la cuenta. Intenta de nuevo.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="authWrap">
      <div className="authCard">
        <div className="brandRow">
          <div className="brandLogo">{/* logo */}</div>
          <div>
            <h1 className="brandTitle">Crear cuenta</h1>
            <p className="brandSub">Es gratis y te guarda tu historial</p>
          </div>
        </div>

        <form onSubmit={onCreate}>
          <div className="field">
            <label className="label">Correo</label>
            <input
              className="input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@correo.com"
              required
              autoComplete="email"
            />
          </div>

          <div className="field">
            <label className="label">Contraseña</label>
            <input
              className="input"
              type="password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
              placeholder="mínimo 6 caracteres"
              required
              autoComplete="new-password"
            />
          </div>

          <div className="field">
            <label className="label">Confirmar contraseña</label>
            <input
              className="input"
              type="password"
              value={pass2}
              onChange={(e) => setPass2(e.target.value)}
              placeholder="repite tu contraseña"
              required
              autoComplete="new-password"
            />
          </div>

          {error ? <div className="errorBox">{error}</div> : null}

          <button className="primaryBtn" disabled={loading}>
            {loading ? "Creando..." : "Crear cuenta"}
          </button>

          <button
            type="button"
            className="secondaryBtn"
            onClick={() => navigate("/login")}
          >
            Ya tengo cuenta
          </button>

          <p className="bottomText">
            Al crear tu cuenta podrás guardar canciones y letras, ver tu historial y crear música cuando quieras.
          </p>

          <div className="rowBetween" style={{ marginTop: 8 }}>
            <span style={{ opacity: 0.8, fontSize: 13 }}>¿Ya tienes cuenta?</span>
            <Link className="linkBtn" to="/login">Iniciar sesión</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
